import { render, staticRenderFns } from "./product-cms-stickers.vue?vue&type=template&id=23d10355"
import script from "./product-cms-stickers.vue?vue&type=script&lang=js"
export * from "./product-cms-stickers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports